export default {
    system_option: [],
    certificate: []
}